/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * Adobe Satellite Abstraction Layer
 */
var SatelliteAnalytics = /** @class */ (function () {
    function SatelliteAnalytics() {
        // Try to use an existing version
        this.digitalData = window.digitalData;
        this.satellite = window._satellite;
    }
    SatelliteAnalytics.prototype.init = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var marketing;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        window.marketingtech = {
                            adobe: {
                                launch: {
                                    property: options.get('property'),
                                    environment: options.get('environment'),
                                },
                                analytics: {
                                    additionalAccounts: options.get('additionalAccounts'),
                                },
                                target: options.get('target'),
                                audienceManager: options.get('audienceManager'),
                            },
                        };
                        if (!(!window.digitalData || !window._satellite)) return [3 /*break*/, 2];
                        return [4 /*yield*/, import('@marketingtech/launch-code/dist/main.min.js')];
                    case 1:
                        marketing = _a.sent();
                        marketing.default;
                        this.digitalData = window.digitalData;
                        this.satellite = window._satellite;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Register data for the specified type
     * @param type
     * @param data
     */
    SatelliteAnalytics.prototype.setData = function (type, data) {
        if (!this.digitalData) {
            return;
        }
        this.digitalData._set(type, data);
    };
    /**
     * Get a snapshot of the current data
     */
    SatelliteAnalytics.prototype.getSnapchot = function () {
        if (!this.digitalData) {
            return;
        }
        this.digitalData._snapshot();
    };
    /**
     * Track the data
     * @param {*} type type "event" or "state"
     */
    SatelliteAnalytics.prototype.satelliteTrack = function (type) {
        var _a, _b;
        if (!this.satellite) {
            return;
        }
        (_b = (_a = this.satellite) === null || _a === void 0 ? void 0 : _a.track) === null || _b === void 0 ? void 0 : _b.call(_a, type, {
            digitalData: this.getSnapchot(),
        });
    };
    /**
     * Delete the data for a specified name
     * @param {*} name the name
     */
    SatelliteAnalytics.prototype.deleteData = function (name) {
        if (!this.digitalData) {
            return;
        }
        this.digitalData._delete(name);
    };
    SatelliteAnalytics.prototype.track = function (trackData) {
        var e_1, _a;
        try {
            for (var _b = __values(trackData.datas), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                this.setData(key, value);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.satelliteTrack('state');
    };
    SatelliteAnalytics.prototype.event = function (eventName, data) {
        this.setData('digitalData.primaryEvent.eventInfo.eventName', eventName);
        if (data) {
            this.setData('digitalData.primaryEvent.attributes', data);
        }
        this.satelliteTrack('event');
        this.deleteData(eventName);
    };
    SatelliteAnalytics.prototype.getTrackDatasRequirements = function () {
        return [
            'page.pageInfo.siteSection',
            'page.pageInfo.template',
            'page.pageInfo.language',
            'page.pageInfo.geoRegion',
            'page.pageInfo.issueDate',
            'page.pageInfo.breadCrumbs',
        ];
    };
    return SatelliteAnalytics;
}());
export default SatelliteAnalytics;
